import { useState, useEffect } from "react";
import { client } from "@/utils/sanity";

export const useHomeData = () => {
  const [home, setHome] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = `*[_type == "home"]`;
        const homeData = await client.fetch(query);
        setHome(homeData);
      } catch (error) {
        console.error("Error fetching home data:", error);
      }
    };

    fetchData();
  }, []);

  return home;
};

